<template>
  <megabit-base-dialog :show-dialog="true" :width="600">
    <template v-slot:body>
      <v-card color="rgba(0, 0, 0, 0.8)">
        <v-card-title class="align-self-center">
          <span class="text-h6 white--text"
            >{{
              $t('title-forms.cadastro', { nome: $t('menu-home.categoria') })
            }}
            (alt+r)</span
          >
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="formValid">
            <v-row dense>
              <v-col cols="6" md="4" lg="2">
                <c-input
                  :label="$t('labels.codigo')"
                  :placeholder="$t('labels.codigo')"
                  :maxLength="10"
                  type="Number"
                  :readonly="true"
                  v-model.trim="form.codigo"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="8" md="8" lg="11">
                <c-input
                  :label="$t('labels.descricao')"
                  :placeholder="
                    $t('placeholders.digite', { campo: $t('labels.descricao') })
                  "
                  :minLength="3"
                  :maxLength="50"
                  :isRequired="true"
                  v-model.trim="form.nome"
                />
              </v-col>
              <v-col cols="2">
                <c-input
                  :label="$t('labels.tipo')"
                  :placeholder="$t('labels.tipo')"
                  min="0"
                  max="9"
                  :maxLength="1"
                  type="Number"
                  v-model.trim="form.tipo"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <form-buttons @submitForm="submitForm()" @goBack="goBack()" />
      </v-card>
    </template>
  </megabit-base-dialog>
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
import cInput from '@/components/shared/base-input/BaseInput'
import FormButtons from '@/components/shared/base-buttons/FormButtons'
import { formRegisterMixin } from '@/mixins/component/form/FormRegisterMixin'
import { mapActions } from 'vuex'

export default {
  mixins: [formRegisterMixin],
  components: {
    'megabit-base-dialog': BaseDialog,
    cInput,
    FormButtons,
  },
  data: () => ({
    form: {
      codigo: '',
      nome: '',
      tipo: '',
    },
  }),
  methods: {
    ...mapActions({
      insert: 'categoryModule/insertCategory',
      update: 'categoryModule/updateCategory',
      getCategory: 'categoryModule/getCategory',
    }),

    async setData() {
      if (this.$route.params && this.$route.params.id > 0) {
        let category = await this.getCategory(this.$route.params.id)
        this.form = {
          ...category,
        }
        this.isUpdate = !this.isUpdate
      }
    },
  },
  mounted() {
    this.setData()
  },
}
</script>
